import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    const page_path = location.pathname + location.search;

    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: "page_view",
        page_location: window.location.href,
        page_path,
      });

      // console.log("📡 page_view fired:", page_path);
    }
  }, [location]);
};
